export type ManagedOAuthAccountLinkMode =
  | 'connected'
  | 'provider_completion'
  | 'direct_link'
  | 'provider_start_required'

export function managedOAuthAccountLinkMode({
  hasActiveLink,
  externalAuthId,
  publicClientId,
}: {
  hasActiveLink: boolean
  externalAuthId: string
  publicClientId: string
}): ManagedOAuthAccountLinkMode {
  if (externalAuthId.trim()) return 'provider_completion'
  if (hasActiveLink) return 'connected'
  if (publicClientId.trim()) return 'direct_link'
  return 'provider_start_required'
}
